const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* 公司資訊 */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg flex items-center justify-center">
                <i className="ri-gamepad-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold">亞立原 Arion</span>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              台灣領先的數位科技與創新服務品牌，專注於遊戲產品代理、研發與市場推廣，致力於鏈結創意與玩家體驗。
            </p>
          </div>

          {/* 快速連結 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">快速連結</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about');
                  }}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  關於我們
                </a>
              </li>
              <li>
                <a 
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('services');
                  }}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  服務項目
                </a>
              </li>
              <li>
                <a 
                  href="#values"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('values');
                  }}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  核心價值
                </a>
              </li>
            </ul>
          </div>

          {/* 聯繫資訊 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">聯繫資訊</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-1"></i>
                <span>ssl.arion.energy@gmail.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-1"></i>
                <span>+886-0975-326-624</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>新北市中和區中山路2段389號3樓</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 版權資訊 */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} 亞立原 Arion. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-400">
            <a href="#" className="hover:text-orange-500 transition-colors">隱私政策</a>
            <a href="#" className="hover:text-orange-500 transition-colors">服務條款</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
